import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExpandMore.js
// module id = 3443
// module chunks = 2